import isEmpty from "lodash/isEmpty";

const initialState = () => ({
  publicUser: {},
  publicUsers: [],
  totalUsers: 0,
  publicUserErrors: {},
});

export default {
  state: initialState(),
  actions: {
    async loadPublicUser({ commit, getters }, payload = {}) {
      if (payload.id === getters.getActivePublicUser && !("_forceload" in payload)) return;
      let res = await this._vm.$api.get("PublicUser", payload);
      if (res.status === 200) {
        commit("setPublicUser", res.data.data);
      }
      return res;
    },

    async loadPublicUsers({ commit, state }, payload = {}) {
      if (!("_forceload" in payload) && !isEmpty(state.publicUsers)) return;
      let res = await this._vm.$api.get("PublicUser", payload);
      if (res.status === 200) {
        commit("setPublicUsers", res.data);
      }
    },

    async fetchPublicUsers({ commit }, payload = {}) {
      let res = await this._vm.$api.get("PublicUser", payload);
      if (res.status === 200) {
        commit("setPublicUsers", res.data);
        return res.data;
      }
      return [];
    },

    async addPublicUser({ commit }, payload = {}) {
      let res = await this._vm.$api.post("PublicUser", payload);
      commit("setPublicUserErrors", "errors" in res.data ? res.data.errors : {});
      if (res.status === 200 || res.status === 201) {
        commit("upsetPublicUsers", res.data.data);
      }
      return res.status === 200 || res.status === 201;
    },

    async editPublicUser({ commit }, payload = {}) {
      let res = await this._vm.$api.put("PublicUser", payload);
      commit("setPublicUserErrors", "errors" in res.data ? res.data.errors : {});
      if (res.status === 200 || res.status === 201) {
        commit("setPublicUser", res.data.data);
        commit("upsetPublicUsers", res.data.data);
      }
      return res.status === 200 || res.status === 201;
    },

    async deletePublicUser({ commit }, payload = {}) {
      let res = await this._vm.$api.delete("PublicUser", payload);
      if (res.status === 200) {
        commit("removePublicUser", payload.id);
      }
      return res.status === 200;
    },
  },

  mutations: {
    setPublicUser(state, data) {
      state.publicUser = data;
    },

    setPublicUsers(state, data) {
      // Handle different response structures
      if (data && data.data && Array.isArray(data.data)) {
        // Structure: { data: [...], meta: { total: ... } }
        state.publicUsers = data.data;

        // Extract total - handle both array and number formats
        if (data.meta && data.meta.total !== undefined) {
          const total = data.meta.total;

          // ROBUST HANDLING: Convert array to number, or use number directly
          if (Array.isArray(total)) {
            // If it's an array like [4, 4], take the first element
            state.totalUsers = parseInt(total[0]) || 0;
          } else if (typeof total === "number") {
            state.totalUsers = total;
          } else if (typeof total === "string") {
            state.totalUsers = parseInt(total) || 0;
          } else {
            state.totalUsers = 0;
          }
        } else {
          state.totalUsers = data.data.length;
        }
      } else if (Array.isArray(data)) {
        // Direct array structure
        state.publicUsers = data;
        state.totalUsers = data.length;
      } else {
        // Fallback for unexpected structures
        state.publicUsers = [];
        state.totalUsers = 0;
      }
    },

    setPublicUserErrors(state, data) {
      state.publicUserErrors = data;
    },

    upsetPublicUsers(state, data) {
      const obj = state.publicUsers.find((o) => o.id === data.id);
      if (obj) {
        Object.assign(obj, data);
      } else {
        state.publicUsers.push(data);
        state.totalUsers++;
      }
    },

    reset(state) {
      Object.assign(state, initialState());
    },

    removePublicUser(state, id) {
      const index = state.publicUsers.findIndex((o) => o.id === id);
      if (index !== -1) {
        state.publicUsers.splice(index, 1);
        state.totalUsers = Math.max(0, state.totalUsers - 1);
      }
    },

    ResetPublicUser(state) {
      const newState = initialState();
      Object.keys(newState).forEach((key) => {
        state[key] = newState[key];
      });
    },
  },

  getters: {
    getPublicUser: (state) => state.publicUser,
    getPublicUsers: (state) => state.publicUsers,
    getTotalUsers: (state) => state.totalUsers, // Always returns a number now
    getActivePublicUser: (state) => (state.publicUser.id ? state.publicUser.id : null),
    getPublicUserErrors: (state) => state.publicUserErrors,
  },
};
